import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { LoginService } from 'src/app/service/login.service';
import { SettingsService } from 'src/app/service/settings.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [MessageService]
})
export class SettingsComponent implements OnInit{

  editingRow: boolean = false;
  items: any [] = []
  idCustomer: number
  editingStates: { [key: number]: boolean } = {};
  nameToSave: string = ''
  customTableStyle: any = { width: '600px' };


  constructor(private messageService: MessageService, private settingsService: SettingsService,
    private loginService: LoginService, private route: ActivatedRoute, private translate: TranslateService) {
    this.idCustomer = loginService.chatCrmUser.idCustomer;
   // Establecer idiomas disponibles y el idioma por defecto
   translate.addLangs(['en', 'es']);
   translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    this.getCatalog()
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  async getCatalog(){
    const response = await this.settingsService.getCatalog(this.idCustomer);
    this.items = response.data.map((item: { mostrar: null; }) => ({
        ...item,
        mostrar: item.mostrar !== null ? item.mostrar : true
    }));
    this.items.sort((a, b) => a.nombre === 'Asignado' ? -1 : b.nombre === 'Asignado' ? 1 : 0);
  }

  updateVisible(idStatus: number){
    this.settingsService.updateVisible(this.idCustomer, idStatus)
      .then(response => {
        this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS_HIDE'), detail: this.translate.instant('SUCCESS_HIDE_MSG') });
        this.getCatalog()
      })
      .catch(error => {
        console.error('Error al actualizar visibilidad:', error);
        this.messageService.add({ severity: 'error', summary: this.translate.instant('ERROR_HIDE'), detail: this.translate.instant('ERROR_NAME_MSG') });
      });
  }
  
  editItem(id: number, item:any) {
    this.nameToSave = item
    this.editingStates[id] = true;
  }

  cancelEdit(id: number) {
    delete this.editingStates[id]; 
  }

  saveChanges(id: number) {
    const item = this.items.find(item => item.id === id); 
    const body = {
      id: id,
      name: this.nameToSave
    };

    this.settingsService.updateName(this.idCustomer, body)
      .then(response => {
        this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS_SETTING'), detail: this.translate.instant('SUCCESS_NAME') });
        this.getCatalog()
        this.cancelEdit(id);
        
      })
      .catch(error => {
        console.error('Error al actualizar nombre:', error);
        this.messageService.add({ severity: 'error', summary: this.translate.instant('ERROR_SETTING'), detail: this.translate.instant('ERROR_NAME') });
      });
  }

    getItemClass(item: any) {
      return item.mostrar ? '' : 'disabled-row';
    }

    isValidName(): boolean {
      return !!this.nameToSave && this.nameToSave.trim() !== '' && this.nameToSave.length <= 15;
    }
    
    
}
